
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-seekers-news",
      function () {
        return require("private-next-pages/job-seekers-news/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/job-seekers-news"])
      });
    }
  